var _path, _ellipse;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.53259 8.65941C3.5446 5.12559 6.41906 2.27059 9.95288 2.2826C13.4867 2.29461 16.3417 5.16907 16.3297 8.70289V8.77535C16.2862 11.0725 15.0036 13.1956 13.4311 14.8551C12.5319 15.7889 11.5276 16.6157 10.4384 17.3188C10.1471 17.5708 9.71514 17.5708 9.4239 17.3188C7.80015 16.262 6.37504 14.9276 5.21375 13.3768C4.17872 12.0245 3.59106 10.3831 3.53259 8.68115L3.53259 8.65941Z",
    stroke: "#FF754C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 9.93116,
    cy: 8.7826,
    rx: 2.05072,
    ry: 2.05072,
    stroke: "#FF754C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/Location.af9fa6266d75921740c8661a7ed9b877.svg";
export { ForwardRef as ReactComponent };